<div
    class="box-container"
    [ngStyle]="{
        'borderRadius.px': radius,
    }">
    @if (logoHeader) {
        <div class="box-container__header">
            @if (!shouldDisplayRI) {
                <button
                    type="button"
                    class="logo-button"
                    (click)="navigateToHome()"
                    title="Ir para página inicial"
                    aria-label="Navegar para página inicial">
                    <img
                        ngSrc="../../../../assets/gray-logo.svg"
                        [width]="logoWidth"
                        [height]="logoHeight"
                        alt="Quiron logo"
                        priority />
                </button>
            } @else {
                <button
                    type="button"
                    class="logo-button text-logo"
                    (click)="navigateToHome()"
                    title="Ir para página inicial"
                    aria-label="Navegar para página inicial">
                    <span>{{ logoText }}</span>
                </button>
            }
        </div>
    }
    <div
        [ngClass]="{
            'box-container__body': true,
            'box-container__body--no-padding': noBodyPadding,
        }">
        <ng-content></ng-content>
    </div>
</div>
